import instance, { ApiResponse } from 'api';
import { AxiosResponse } from 'axios';
import { endpoints } from 'endpoints.config';
import { NO_RESPONSE } from './cardPaymentErrors';
import {
  CardApiResult,
  CardFinaliseResult,
  CardOrderRequest,
  CardOrderResult,
  CardOrderRole,
} from './types';

const urls = {
  public: {
    card: endpoints.public.subscription.card,
    finalise: endpoints.public.subscription.cardFinalise,
  },
  school: {
    card: endpoints.subscriptions.card,
    finalise: endpoints.subscriptions.cardFinalise,
  },
};

const firstErrorCode = (errors: any): string =>
  (Array.isArray(errors) && errors[0] && errors[0].messageCode) || '';

const post = async <T>(url: string, body: object): Promise<CardApiResult<T>> => {
  try {
    const result: AxiosResponse<ApiResponse<T>> = await instance.post(url, body);

    if (result.data.status === '1') {
      return { data: result.data.details, error: null };
    }

    return { data: null, error: { code: firstErrorCode(result.data.errors) } };
  } catch (error: any) {
    if (error.response && error.response.data) {
      return { data: null, error: { code: firstErrorCode(error.response.data.errors) } };
    }

    return { data: null, error: { code: NO_RESPONSE } };
  }
};

export const createCardOrder = (role: CardOrderRole, request: CardOrderRequest) =>
  post<CardOrderResult>(urls[role].card, request);

export const finaliseCardOrder = (role: CardOrderRole, orderReference: string) =>
  post<CardFinaliseResult>(urls[role].finalise, { orderReference });
